<div class="content">
	<div>
		<section class="bar timer-bar">
			<div class="row">
				<div>
					<a
						href="#"
						(click)="goBack()"
						class="btn no-margin"
					>
						{{ "auction.live.comeBack" | translate }}
					</a>
				</div>
				<div>
					<span class="label">{{ "auction.live.time" | translate }}</span> <span class="value">{{ nowTime | ckDate: false : false : false : true : true }}</span>
				</div>
			</div>
		</section>
		@if (observed) {
			<app-live-item [observedAuctionDTO]="observed"></app-live-item>
		}
		<section class="bar timer-bar">
			<div class="row">
				<div>
					<a
						(click)="goBack()"
						class="btn no-margin"
					>
						{{ "auction.live.comeBack" | translate }}
					</a>
				</div>
				<div>
					<span class="label">{{ "auction.live.time" | translate }}</span> <span class="value">{{ nowTime | ckDate: false : false : false : true : true }}</span>
				</div>
			</div>
		</section>

		<section class="auction-legend">
			<ul class="p-0">
				<li class="legend-green d-inline-block">
					<strong class="lh-lg">
						<span class="align-middle">{{ "auction.live.migliorOff" | translate }}</span>
					</strong>
				</li>
				<li class="legend-red d-lg-inline-block ms-lg-4">
					<strong class="lh-lg">
						<span class="align-middle">{{ "auction.live.offertaSup" | translate }}</span>
					</strong>
				</li>
				<li class="legend-yellow d-lg-inline-block ms-lg-4">
					<strong class="lh-lg">
						<span class="align-middle">{{ "auction.live.riservaNonRag" | translate }}</span>
					</strong>
				</li>
			</ul>
			<p>
				{{ "auction.live.noOffers" | translate }}<br />
				{{ "auction.live.impegnoAcquisto" | translate }}
			</p>
		</section>
	</div>
</div>